import React from 'react';
import {Form, Modal} from "react-bootstrap";

const EditUser = ({show, handleClose}) => {
    return (

        <Modal show={show} onHide={handleClose} centered>
            <div className="modal-content">
                <div className="modal-header">
                    <h1 className="modal-title fs-5" id="exampleModalLabel">Edit User</h1>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
                </div>
                <div className="modal-body">
                    <Form>
                        <Form.Control
                            placeholder={'Enter name of new Genre'}
                        />
                    </Form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>Close</button>
                    <button type="button" className="btn btn-primary" onClick={handleClose}>Write to DB</button>
                </div>
            </div>
        </Modal>


    );
};

export default EditUser;